module.exports = __webpack_public_path__ + "img/hotdog_chili.cd08d134.jpeg";